import { ClientType } from 'src/types/client';

import type { OrderRequest } from 'src/types/order';

/**
 * Whether a client may see Net Price anywhere: the order requests table, a request's
 * detail page, and the order form's preview step all gate on this one rule, so a
 * client who cannot see pricing in the list cannot see it anywhere else either.
 *
 * Faculty see it only when they are the paying customer; institution admins manage
 * an institution's packs but never see pricing. Everyone else does.
 */
export const canSeeNetPrice = ({
  clientType,
  isFacultyCustomer = false,
}: {
  clientType?: ClientType;
  isFacultyCustomer?: boolean | null;
}) => {
  if (clientType === ClientType.CreatorInstitutionAdmin) return false;
  if (clientType === ClientType.CreatorFaculty)
    return Boolean(isFacultyCustomer);

  return true;
};

const filterOrderRequests = (
  requests: OrderRequest[],
  {
    selectedBookstores = [],
    searchQuery = '',
  }: { selectedBookstores?: number[]; searchQuery?: string }
): OrderRequest[] => {
  let requestList = requests;

  if (selectedBookstores.length > 0) {
    requestList = requestList.filter((request) =>
      selectedBookstores.includes(Number(request.bookstoreId))
    );
  }

  const q = searchQuery.trim().toLowerCase();
  if (q) {
    requestList = requestList.filter((request) => {
      const professorNames = request.professors
        .map((p) => p.name)
        .join(' ')
        .toLowerCase();
      return (
        request.courseName.toLowerCase().includes(q) ||
        request.courseNumber.toLowerCase().includes(q) ||
        professorNames.includes(q) ||
        (request.term?.name ?? '').toLowerCase().includes(q) ||
        (request.sku ?? '').toLowerCase().includes(q)
      );
    });
  }

  return requestList;
};

export default filterOrderRequests;
